'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVid = exports.getThreadPreview = exports.getVisitor = exports.getInboxId = exports.getLatestMessage = exports.getWelcomeMessageId = exports.getUnseenCount = exports.getResponder = exports.getLatestMessageTimestamp = exports.getLatestEmailMessageTimestamp = exports.getLatestEmailMessage = exports.getAgentChannel = exports.getChannel = exports.getStatus = exports.getAssignedAgentId = exports.getIsThreadFiltered = exports.getFilterSourceFromThread = exports.getThreadId = exports.getSource = exports.getLatestMessageSeen = exports.getLatestEmailSenderType = exports.getLatestReadTimestamp = exports.getAssignedAgentType = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _KeyPaths = require('../constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAssignedAgentType = exports.getAssignedAgentType = (0, _getIn2.default)(_KeyPaths.ASSIGNED_AGENT_TYPE);

var getLatestReadTimestamp = exports.getLatestReadTimestamp = (0, _getIn2.default)(_KeyPaths.LATEST_READ_TIMESTAMP);

var getLatestEmailSenderType = exports.getLatestEmailSenderType = (0, _getIn2.default)(_KeyPaths.LATEST_EMAIL_SENDER_TYPE);

var getLatestMessageSeen = exports.getLatestMessageSeen = (0, _getIn2.default)(_KeyPaths.LATEST_MESSAGE_SEEN);

var getSource = exports.getSource = (0, _getIn2.default)(_KeyPaths.SOURCE);

var getThreadId = exports.getThreadId = (0, _getIn2.default)(_KeyPaths.THREAD_ID);

var getFilterSourceFromThread = exports.getFilterSourceFromThread = (0, _getIn2.default)(_KeyPaths.FILTER_SOURCE);

var getIsThreadFiltered = exports.getIsThreadFiltered = (0, _getIn2.default)(_KeyPaths.FILTERED);

var getAssignedAgentId = exports.getAssignedAgentId = (0, _getIn2.default)(_KeyPaths.ASSIGNEE);

var getStatus = exports.getStatus = (0, _getIn2.default)(_KeyPaths.STATUS);

var getChannel = exports.getChannel = (0, _getIn2.default)(_KeyPaths.CHANNEL);

var getAgentChannel = exports.getAgentChannel = (0, _getIn2.default)(_KeyPaths.AGENT_CHANNEL);

var getLatestEmailMessage = exports.getLatestEmailMessage = (0, _getIn2.default)(_KeyPaths.LATEST_EMAIL_MESSAGE);

var getLatestEmailMessageTimestamp = exports.getLatestEmailMessageTimestamp = (0, _getIn2.default)(_KeyPaths.LATEST_EMAIL_TIMESTAMP);

var getLatestMessageTimestamp = exports.getLatestMessageTimestamp = (0, _getIn2.default)(_KeyPaths.LATEST_MESSAGE_TIMESTAMP);

var getResponder = exports.getResponder = (0, _getIn2.default)(_KeyPaths.RESPONDER);

var getUnseenCount = exports.getUnseenCount = (0, _getIn2.default)(_KeyPaths.UNSEEN_COUNT);

var getWelcomeMessageId = exports.getWelcomeMessageId = (0, _getIn2.default)(_KeyPaths.WELCOME_MESSAGE_ID);

var getLatestMessage = exports.getLatestMessage = (0, _getIn2.default)(_KeyPaths.LATEST_MESSAGE);

var getInboxId = exports.getInboxId = (0, _getIn2.default)(_KeyPaths.INBOX_ID);

var getVisitor = exports.getVisitor = (0, _getIn2.default)(_KeyPaths.VISITOR);

var getThreadPreview = exports.getThreadPreview = (0, _getIn2.default)(_KeyPaths.THREAD_PREVIEW);

var getVid = exports.getVid = (0, _getIn2.default)(_KeyPaths.VID);